import { render, staticRenderFns } from "./MotorSchedule.vue?vue&type=template&id=b1870e6a&"
import script from "./MotorSchedule.vue?vue&type=script&lang=js&"
export * from "./MotorSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports